import { put, call, debounce } from "redux-saga/effects";
import { request, handleErrors, toQueryString } from "../../services/helpers";
import * as invoiceActions from "../actions/invoice";
import { REQUEST } from "../actions/index";

function getInvoices(filter) {
  return request.get(`invoices/allInvoicesForAdmin?${toQueryString(filter)}`);
}

function* getInvoicesByBuilding(action) {
  try {
    const invoices = yield call(getInvoices, action.payload);
    yield put(invoiceActions.invoice.success(invoices.data.invoices));
  } catch (e) {
    yield put(invoiceActions.invoice.failure(handleErrors(e)));
  }
}

export function* invoiceWatcher() {
  yield debounce(500, invoiceActions.INVOICES[REQUEST], getInvoicesByBuilding);
}
